export default function ObtenerTrimestreActual() {
  const fechaActual = new Date();
  const mes = fechaActual.getMonth();
  const trimestre = Math.floor(mes / 3) + 1; // Trimestre = mes actual / 3 (redondeado hacia abajo) + 1
  const año = fechaActual.getFullYear();

  return trimestre + "Q" + año;
}
